import styled from 'styled-components';

export const StyledNotifications = styled.div`
  .notifications {
    margin-top: 50px;
    padding: 12px 20px 20px;
    border: 1px solid ${props => props.theme.borderLight};
    border-radius: 28px;
    &-actions {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
      h3 {
        margin: 0;
        margin-inline-end: 15px;
        font-size: 18px;
        font-weight: bold;
      }
    }
    &-list {
      padding: 0 25px;
      direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
      li {
        position: relative;
        padding: 8px 25px 25px;
        background: #fff;
        box-shadow: 0 3px 34px rgba(89, 102, 137, 0.05);
        border-radius: 25px;
        & + li {
          margin-top: 20px;
        }
        p {
          padding: 25px 0;
          margin: 0;
        }
        .bg {
          position: absolute;
          top: -34px;
          left: -35px;
          z-index: 0;
        }
        .item-content {
          position: relative;
          z-index: 1;
        }
      }
      .actions {
        display: flex;
        gap: 18px;
      }
      .data {
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        font-size: 15px;
        color: rgba(55, 54, 71, .6);
        border-bottom: 1px solid rgba(216, 210, 255, .5);
        & > * {
          margin-inline-end: 30px;
        }
        .address {
          display: flex;
          flex-direction: column;
        }
        .street {
          font-size: 12px;
        }
        a {
          color: ${props => props.theme.main};
          text-decoration: underline;
          &:hover {
            text-decoration: none;
          }
        }
      }
      .name {
        span + span {
          margin-right: 5px;
        }
      }
    }
  }
  .select {
    width: 210px;
    margin-inline-end: 40px;
  }
  .switch {
    display: flex;
    align-items: center;

    span {
      margin-inline-end: 11px;
      font-size: 14px;
    }
  }
`;